import { api } from "@";
import {
  AssignDriverRequest,
  AssignDriverRequestPayload,
  DonationsSearchValues,
  IgnoreFromVerificationRequest,
  IgnoreFromVerificationRequestPayload,
} from "../types.ts";
import { searchHandler } from "@/features/operations/verifications/donations/lib/helpers.ts";
import { donationsSearchValues } from "@/features/operations/verifications/donations/lib/options.ts";

// ============================================
// Donations API (Unassigned Stages)
// ============================================

// Fetch unassigned verification stages
export const getUnassignedStages = (
  page: number = 1,
  pageSize: number | null = null,
  search: DonationsSearchValues,
) => {
  const payload = searchHandler(search);

  return api.post("/api/AdminVerification/unassigned-verification-stages/v2", {
    page,
    pageSize,
    ...payload,
  });
};

// export unassigned verification stages excel
export const exportUnassignedVerificationStagesExcel = (
  page: number = 1,
  pageSize: number | string = "",
  search: DonationsSearchValues,
) => {
  const payload = searchHandler(search);
  return api.post(
    `/api/AdminVerification/export-verification-stages`,
    {
      page,
      pageSize,
      ...payload,
    },
    {
      responseType: "blob",
    },
  );
};

// Assign driver to verification stages
export const assignDriverToVerificationStages = (form: AssignDriverRequest) => {
  const payload: AssignDriverRequestPayload = {
    driverId: form.driverId.toString(),
    verificationStages: [],
    searchUnAssignedVerificationStagesRequestViewModel: searchHandler(
      donationsSearchValues,
    ),
  };

  if (form.selectingAll) {
    payload.searchUnAssignedVerificationStagesRequestViewModel = searchHandler(
      form.searchValues,
    );
  } else {
    payload.verificationStages = form.verificationStages;
  }

  return api.post(
    "/api/AdminVerification/assign-driver-to-verification-stages",
    payload,
  );
};

// Ignore from verification
export const ignoreFromVerification = (form: IgnoreFromVerificationRequest) => {
  const payload: IgnoreFromVerificationRequestPayload = {
    verificationStages: [],
    searchUnAssignedVerificationStagesRequestViewModel: searchHandler(
      donationsSearchValues,
    ),
  };

  if (form.selectingAll) {
    payload.searchUnAssignedVerificationStagesRequestViewModel = searchHandler(
      form.searchValues,
    );
  } else {
    payload.verificationStages = form.verificationStages;
  }

  return api.put("/api/AdminVerification/ignore-from-verification", payload);
};

// Create manual verification stages
export const createManualVerificationStages = (orderId: number) =>
  api.post(
    `/api/AdminVerification/create-manual-verification-stages/${orderId}`,
  );
